;(function (module) {
  'use strict'
  module.controller('SmsController', [
    '$rootScope',
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'socket',
    'socketLogin',
    'authService',
    'conversationService',
    'members',
    'tripsDashBoard',
    'progressBar',
    'ngDialog',
    'commonDialog',
    'commonDialogMessage',
    'currency',
    'smsStatus',
    'Upload',
    'providers',
    'fileReader',
    function (
      $rootScope,
      $scope,
      $http,
      $state,
      $stateParams,
      socket,
      socketLogin,
      authService,
      conversationService,
      members,
      tripsDashBoard,
      progressBar,
      ngDialog,
      commonDialog,
      commonDialogMessage,
      currency,
      smsStatus,
      Upload,
      providers,
      fileReader,
    ) {
      //var progress = progressBar.getProgressBar()
      var dialogId
      $scope.istravellerIgnore = false
      //Helper private functions
      function getFlightContext(bookingId) {
        tripsDashBoard.getFlightsDashById(bookingId).then(
          function (flights) {
            let contextData = flights.data
            let statusColor = '#000000' //black
            let flightStatus = 'scheduled'
            let dateTime = new Date()
            let arrivalTime = moment(contextData.ArrivalDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            )
            let currentDateTime = moment(dateTime).format('MM-DD-YYYY h:mm:ss')
            if (contextData.FlightStat !== null) {
              let departureTime = moment(contextData.DepartureDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              )
              let estimatedDeparuteTime = moment(
                contextData.FlightStat.EstimatedDeparture,
              ).format('MM-DD-YYYY h:mm:ss')
              let estimatedArrival = moment(
                contextData.FlightStat.EstimatedArrival,
              ).format('MM-DD-YYYY h:mm:ss')
              statusColor =
                departureTime === estimatedDeparuteTime ||
                estimatedDeparuteTime < departureTime
                  ? '#3d9400'
                  : estimatedDeparuteTime > departureTime
                  ? '#cc0000'
                  : statusColor
              flightStatus =
                departureTime === estimatedDeparuteTime ||
                estimatedDeparuteTime < departureTime
                  ? 'on time'
                  : estimatedDeparuteTime > departureTime
                  ? 'delayed'
                  : currentDateTime > estimatedArrival
                  ? 'past flight'
                  : flightStatus
            }
            if (contextData.Cancelled === true) {
              statusColor = '#cc0000' //red
              flightStatus = 'cancelled'
            }
            if (
              contextData.FlightStat === null &&
              currentDateTime > arrivalTime
            ) {
              flightStatus = 'past flight'
            }
            $scope.flightContext = {
              statusColor: statusColor,
              flightStatus: flightStatus,
              estimatedDeparture:
                contextData.FlightStat !== null &&
                contextData.FlightStat.EstimatedDeparture !== null
                  ? contextData.FlightStat.EstimatedDeparture
                  : contextData.DepartureDateTime,
              estimatedArrival:
                contextData.FlightStat !== null &&
                contextData.FlightStat.EstimatedArrival !== null
                  ? contextData.FlightStat.EstimatedArrival
                  : contextData.ArrivalDateTime,
              pnr: contextData.Pnr,
              depart:
                contextData.DepartureName +
                ' (' +
                contextData.DepartureAirport +
                ')',
              arrival:
                contextData.ArrivalName +
                ' (' +
                contextData.ArrivalAirport +
                ')',
              departureName: contextData.DepartureName,
              departureAirport: contextData.DepartureAirport,
              departureDateTime: moment(contextData.DepartureDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              departureGate:
                contextData.FlightStat !== null &&
                contextData.FlightStat.DepartureGate !== null
                  ? contextData.FlightStat.DepartureGate
                  : '-',
              departureTerminal:
                contextData.FlightStat !== null &&
                contextData.FlightStat.DepartureTerminal !== null
                  ? contextData.FlightStat.DepartureTerminal
                  : '-',
              startDate: contextData.DepartureDateTime,
              endDate: contextData.ArrivalDateTime,
              arrivalName: contextData.ArrivalName,
              arrivalAirport: contextData.ArrivalAirport,
              arrivalDateTime: moment(contextData.ArrivalDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              arrivalGate:
                contextData.FlightStat !== null &&
                contextData.FlightStat.ArrivalGate !== null
                  ? contextData.FlightStat.ArrivalGate
                  : '-',
              arrivalTerminal:
                contextData.FlightStat !== null &&
                contextData.FlightStat.ArrivalTerminal !== null
                  ? contextData.FlightStat.ArrivalTerminal
                  : '-',
              operatingAirline: contextData.OperatingAirline,
              flightNumber: contextData.FlightNumber,
              duration: contextData.Duration,
              bookingSource: contextData.BookingSource,
              confirmation: contextData.ConfirmationNumber,
              cabin: contextData.Cabin,
              bookingClass: contextData.BookingClass,
              numberInParty: contextData.NumberInParty,
              airTravelers: contextData.AirReservation.AirTravelers,
              comment: contextData.AirReservation.Comment,
              seats: contextData.Seats,
              totalCharge:
                currency.getCurrencySymbol(
                  contextData.AirReservation.CurrencyCode,
                ) + contextData.AirReservation.TotalFare,
              lastUpdated: moment(contextData.Updated).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              isDeleted: contextData.Deleted ? 'Yes' : 'No',
              vendor: contextData.Vendor,
            }
          },
          function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`
                    $scope.errTitle = 'SMS History Error'
                  },
                ],
              })
            }
          },
        )
      }

      function getHotelContext(bookingId) {
        const promiseGetHotel = tripsDashBoard.getHotelsDashById(bookingId)
        promiseGetHotel.then(function (hotels) {
          console.log(hotels)
          var contextData = hotels.data
          ;($scope.hotelContext = {
            pnr: contextData.Pnr,
            hotelName: contextData.HotelName,
            address: contextData.Address,
            checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
            checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            guestNames: contextData.GuestNames,
            numberOfRooms: contextData.NumberOfRooms,
            roomType: contextData.RoomType,
            totalCharge:
              contextData.Total +
              ' ' +
              (contextData.CurrencyCode === null
                ? ''
                : contextData.CurrencyCode),
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
          }),
            function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template:
                    '<p>' +
                    err.statusText +
                    '</p>' +
                    '<div class="ngdialog-buttons">' +
                    '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Ok' +
                    '</button>' +
                    '</div>',
                  className: 'ngdialog-theme-plain',
                  plain: true,
                })
              }
            }
        })
      }

      function getCarContext(bookingId) {
        const promiseGetCar = tripsDashBoard.getCarsDashById(bookingId)
        promiseGetCar.then(function (cars) {
          console.log(cars)
          var contextData = cars.data
          ;($scope.carContext = {
            pnr: contextData.Pnr,
            rentalCompany: contextData.RentalCompany,
            pickupDateTime: moment(contextData.PickUpDateTime).format(
              'MM-DD-YYYY h:mm',
            ),
            pickupLocation: contextData.PickUpLocation,
            pickupLocationIsAirport:
              contextData.PickUpAtAirport === true ? 'Yes' : 'No',
            pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
            pickupLocationCode: contextData.PickUpLocationCode,
            dropoffDateTime: moment(contextData.DropOffDateTime).format(
              'MM-DD-YYYY h:mm',
            ),
            dropoffLocation: contextData.DropOffLocation,
            dropoffLocationIsAirport:
              contextData.DropOffAtAirport === true ? 'Yes' : 'No',
            dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
            dropoffLocationCode: contextData.DropOffLocationCode,
            carModel: contextData.CarModel,
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            totalCharge:
              contextData.TotalCharge +
              ' ' +
              (contextData.CurrencyCode === null
                ? ''
                : contextData.CurrencyCode),
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
          }),
            function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template:
                    '<p>' +
                    err.statusText +
                    '</p>' +
                    '<div class="ngdialog-buttons">' +
                    '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Ok' +
                    '</button>' +
                    '</div>',
                  className: 'ngdialog-theme-plain',
                  plain: true,
                })
              }
            }
        })
      }

      function generateFlightContext(flightContext) {
        return flightContext.map(function (contextData) {
          let statusColor = '#000000' //black
          let flightStatus = 'scheduled'
          let currentDateTime = new Date()
          let arrivalTime = moment(contextData.ArrivalDateTime).format(
            'MM-DD-YYYY h:mm:ss',
          )
          currentDateTime = moment(currentDateTime).format('MM-DD-YYYY h:mm:ss')
          if (contextData.FlightStat !== null) {
            let departureTime = moment(contextData.DepartureDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            )
            let estimatedDeparuteTime = moment(
              contextData.FlightStat.EstimatedDeparture,
            ).format('MM-DD-YYYY h:mm:ss')
            let estimatedArrival = moment(
              contextData.FlightStat.EstimatedArrival,
            ).format('MM-DD-YYYY h:mm:ss')
            statusColor =
              departureTime === estimatedDeparuteTime ||
              estimatedDeparuteTime < departureTime
                ? '#3d9400'
                : estimatedDeparuteTime > departureTime
                ? '#cc0000'
                : statusColor
            flightStatus =
              departureTime === estimatedDeparuteTime ||
              estimatedDeparuteTime < departureTime
                ? 'on time'
                : estimatedDeparuteTime > departureTime
                ? 'delayed'
                : currentDateTime > estimatedArrival
                ? 'past flight'
                : flightStatus
          }
          if (contextData.Cancelled === true) {
            statusColor = '#cc0000' //red
            flightStatus = 'cancelled'
          }
          if (
            contextData.FlightStat === null &&
            currentDateTime > arrivalTime
          ) {
            flightStatus = 'past flight'
          }
          return {
            statusColor: statusColor,
            flightStatus: flightStatus,
            estimatedDeparture:
              contextData.FlightStat !== null &&
              contextData.FlightStat.EstimatedDeparture !== null
                ? contextData.FlightStat.EstimatedDeparture
                : contextData.DepartureDateTime,
            estimatedArrival:
              contextData.FlightStat !== null &&
              contextData.FlightStat.EstimatedArrival !== null
                ? contextData.FlightStat.EstimatedArrival
                : contextData.ArrivalDateTime,
            pnr: contextData.Pnr,
            bookingTypeName: 'A',
            bookingType: 'Airline Reservation',
            depart:
              contextData.DepartureName +
              ' (' +
              contextData.DepartureAirport +
              ')',
            arrival:
              contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
            departureName: contextData.DepartureName,
            departureAirport: contextData.DepartureAirport,
            departureDateTime: moment(contextData.DepartureDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            departureGate:
              contextData.FlightStat !== null &&
              contextData.FlightStat.DepartureGate !== null
                ? contextData.FlightStat.DepartureGate
                : '-',
            departureTerminal:
              contextData.FlightStat !== null &&
              contextData.FlightStat.DepartureTerminal !== null
                ? contextData.FlightStat.DepartureTerminal
                : '-',
            startDate: contextData.DepartureDateTime,
            endDate: contextData.ArrivalDateTime,
            arrivalName: contextData.ArrivalName,
            arrivalAirport: contextData.ArrivalAirport,
            arrivalDateTime: moment(contextData.ArrivalDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            arrivalGate:
              contextData.FlightStat !== null &&
              contextData.FlightStat.ArrivalGate !== null
                ? contextData.FlightStat.ArrivalGate
                : '-',
            arrivalTerminal:
              contextData.FlightStat !== null &&
              contextData.FlightStat.ArrivalTerminal !== null
                ? contextData.FlightStat.ArrivalTerminal
                : '-',
            operatingAirline: contextData.OperatingAirline,
            flightNumber: contextData.FlightNumber,
            duration: contextData.Duration,
            bookingSource: contextData.BookingSource,
            confirmation: contextData.ConfirmationNumber,
            cabin: contextData.Cabin,
            bookingClass: contextData.BookingClass,
            numberInParty: contextData.NumberInParty,
            airTravelers: contextData.AirReservation.AirTravelers,
            comment: contextData.AirReservation.Comment,
            seats: contextData.Seats,
            totalCharge:
              currency.getCurrencySymbol(
                contextData.AirReservation.CurrencyCode,
              ) + contextData.AirReservation.TotalFare,
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted ? 'Yes' : 'No',
            vendor: contextData.Vendor,
          }
        })
      }

      function generateCarContext(carContext) {
        return carContext.map(function (contextData) {
          return {
            bookingTypeName: 'C',
            bookingType: 'Car Reservation',
            pnr: contextData.Pnr,
            startDate: contextData.PickUpDateTime,
            rentalCompany: contextData.RentalCompany,
            pickupDateTime: moment(contextData.PickUpDateTime).format(
              'MM-DD-YYYY h:mm',
            ),
            pickupLocation: contextData.PickUpLocation,
            pickupLocationIsAirport:
              contextData.PickUpAtAirport === true ? 'Yes' : 'No',
            pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
            pickupLocationCode: contextData.PickUpLocationCode,
            dropoffDateTime: moment(contextData.DropOffDateTime).format(
              'MM-DD-YYYY h:mm',
            ),
            dropoffLocation: contextData.DropOffLocation,
            dropoffLocationIsAirport:
              contextData.DropOffAtAirport === true ? 'Yes' : 'No',
            dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
            dropoffLocationCode: contextData.DropOffLocationCode,
            carModel: contextData.CarModel,
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            totalCharge:
              contextData.TotalCharge +
              ' ' +
              (contextData.CurrencyCode === null
                ? ''
                : contextData.CurrencyCode),
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
          }
        })
      }

      function generateHotelContext(hotelContext) {
        return hotelContext.map(function (contextData) {
          return {
            bookingTypeName: 'H',
            bookingType: 'Hotel Reservation',
            pnr: contextData.Pnr,
            startDate: contextData.CheckInDate,
            hotelName: contextData.HotelName,
            address: contextData.Address,
            checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
            checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            guestNames: contextData.GuestNames,
            numberOfRooms: contextData.NumberOfRooms,
            roomType: contextData.RoomType,
            totalCharge:
              contextData.Total +
              ' ' +
              (contextData.CurrencyCode === null
                ? ''
                : contextData.CurrencyCode),
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
          }
        })
      }

      function getAllContexts(bookingId) {
        $scope.contextList = []
        let tripFlightContext = []
        let tripCarContext = []
        let tripHotelContext = []
        tripsDashBoard.getTripsDashbyId(bookingId).then(function (trips) {
          tripFlightContext = trips.data.Flights
          tripCarContext = trips.data.Cars
          tripHotelContext = trips.data.Hotels
          let flightList = []
          let hotelList = []
          let carList = []
          if (!!tripFlightContext.length) {
            flightList = generateFlightContext(tripFlightContext)
          }
          if (!!tripCarContext.length) {
            carList = generateCarContext(tripCarContext)
          }
          if (!!tripHotelContext.length) {
            hotelList = generateHotelContext(tripHotelContext)
          }
          $scope.contextList = [flightList, carList, hotelList].reduce(
            function (prevData, currData) {
              return prevData.concat(currData)
            },
            [],
          )
          let sortByDateAsc = function (a, b) {
            let firstStartDate = moment(a.startDate).format('MM-DD-YYYY')
            let secondStartDate = moment(b.startDate).format('MM-DD-YYYY')
            if (firstStartDate > secondStartDate) {
              return 1
            } else if (firstStartDate < secondStartDate) {
              return -1
            } else if (firstStartDate === secondStartDate) {
              if (a.bookingTypeName === 'A') {
                return -1
              } else if (b.bookingTypeName === 'A') {
                return 1
              } else if (
                a.bookingTypeName === 'H' &&
                b.bookingTypeName === 'C'
              ) {
                return -1
              } else if (
                a.bookingTypeName === 'C' &&
                b.bookingTypeName === 'H'
              ) {
                return 1
              } else {
                return 0
              }
            }
          }
          $scope.contextList.sort(sortByDateAsc)
        })
      }

      function setBookingDetails(topic) {
        const bookingId =
          topic && topic.BookingId ? topic.BookingId : topic.bookingId
        const bookingType =
          topic && topic.BookingType ? topic.BookingType : topic.bookingType
        if (bookingType === 'FlightViewModel' || bookingType === 'Flight') {
          $scope.bookingType = 'Airline Reservation'
          getFlightContext(bookingId)
        } else if (
          bookingType === 'HotelViewModel' ||
          bookingType === 'Hotel'
        ) {
          $scope.bookingType = 'Hotel Reservation'
          getHotelContext(bookingId)
        } else if (bookingType === 'CarViewModel' || bookingType === 'Car') {
          $scope.bookingType = 'Car Reservation'
          getCarContext(bookingId)
        } else if (bookingType === 'TripViewModel' || bookingType === 'Trip') {
          $scope.bookingType = 'Trip'
          getAllContexts(bookingId)
        }
        console.log('$scope.bookingType = ', $scope.bookingType)
      }
      //init of page
      function checkFirstVisit() {
        if (document.cookie.indexOf('mycookie') == -1) {
          // cookie doesn't exist, create it now
          document.cookie = 'mycookie=1'
        } else {
          setTimeout(() => {
            console.log('On refresh page')
            console.log('socket id', socketLogin.getSocketId())
            console.log('socket id', authService.getLoginMember().Email)
            conversationService
              .updateSocketId({
                socketId: socketLogin.getSocketId(),
                email: authService.getLoginMember().Email,
              })
              .then(function (response) {
                console.log('updateSocketId', response)
              })
          }, 2000)
        }
      }
      console.log($stateParams) //{fromNumber: "13462764357", firstName: firstName, lastName: lastName}
      console.log($state.params)
      console.log(authService.getLoginMember())
      if ($stateParams.channel === null && $stateParams.fromNumber === null) {
        checkFirstVisit()
        // window.location.replace(
        //   window.location.href.split(window.location.hash)[0],
        // )
      }
      const {
        fromNumber,
        travelerFirstName: firstName,
        travelerLastName: lastName,
        travelerId,
        travelerOrganizationName: organizationName,
        topic,
        channel,
      } = $state.params
      $scope.traveler = {}
      $scope.channel = channel
      $scope.filesToSend = []
      $scope.isSending = false

      if (fromNumber) {
        $scope.isInConversation = true

        if (channel === 'messenger') {
          $scope.conversationTitle = `${firstName} ${lastName} from ${organizationName} via Messenger`
        } else if (channel === 'sms') {
          $scope.conversationTitle = `${firstName} ${lastName} from ${organizationName} via SMS (+${fromNumber})`
        } else {
          $scope.conversationTitle = `${firstName} ${lastName} from ${organizationName}`
        }

        //messages
        members.getMemberById(travelerId).then((res) => {
          const memberInfo = res.data
          $scope.traveler = res.data
          const loginMember = authService.getLoginMember()
          conversationService
            .getConversation(fromNumber)
            .then(async function (response) {
              const conversationData = response.data
              console.log('memberInfo 567', memberInfo)
              $scope.chats = conversationData.map(function (message) {
                if (message.isBot) {
                  let val
                  try {
                    val = JSON.parse(message.message)
                    console.log('DEBUG => ', val)
                    if (typeof val === 'object' || val instanceof Object) {
                      const templateType = val.template_type
                      if (templateType === 'generic') {
                        const elements = val.elements
                        return {
                          direction: 'out',
                          img: 'images/avatar/bot.png',
                          name: 'Obex Bot',
                          time: moment(message.time).format(
                            'MM-DD-YYYY h:mm:ss a',
                          ),
                          message: undefined,
                          template: elements.map((m) => {
                            return {
                              title: m.title,
                              subtitle: m.subtitle,
                              image_url: m.image_url,
                            }
                          }),
                          templateType: templateType,
                          mediaUrl0: message.mediaUrl0,
                          mediaUrl1: message.mediaUrl1,
                          mediaUrl2: message.mediaUrl2,
                        }
                      } else if (
                        templateType === 'airline_itinerary' ||
                        templateType === 'airline_checkin'
                      ) {
                        return {
                          direction: 'out',
                          img: 'images/avatar/bot.png',
                          name: 'Obex Bot',
                          time: moment(message.time).format(
                            'MM-DD-YYYY h:mm:ss a',
                          ),
                          message: undefined,
                          template: {
                            intro_message: val.intro_message,
                            pnr_number: val.pnr_number,
                            passenger_info: val.passenger_info[0],
                            flight_info: val.flight_info[0],
                            passenger_segment_info:
                              val.passenger_segment_info[0],
                            total_price: val.total_price,
                            currency: val.currency,
                          },
                          templateType: templateType,
                          mediaUrl0: message.mediaUrl0,
                          mediaUrl1: message.mediaUrl1,
                          mediaUrl2: message.mediaUrl2,
                        }
                      } else if (templateType === 'airline_update') {
                        return {
                          direction: 'out',
                          img: 'images/avatar/bot.png',
                          name: 'Obex Bot',
                          time: moment(message.time).format(
                            'MM-DD-YYYY h:mm:ss a',
                          ),
                          message: undefined,
                          template: {
                            intro_message: val.intro_message,
                            pnr_number: val.pnr_number,
                            flight_info: val.update_flight_info,
                          },
                          templateType: templateType,
                          mediaUrl0: message.mediaUrl0,
                          mediaUrl1: message.mediaUrl1,
                          mediaUrl2: message.mediaUrl2,
                        }
                      } else if (templateType === 'list') {
                        const elements = val.elements
                        return {
                          direction: 'out',
                          img: 'images/avatar/bot.png',
                          name: 'Obex Bot',
                          time: moment(message.time).format(
                            'MM-DD-YYYY h:mm:ss a',
                          ),
                          message: undefined,
                          template: elements.map((m) => {
                            return {
                              title: m.title,
                              subtitle: m.subtitle,
                            }
                          }),
                          templateType: templateType,
                          mediaUrl0: message.mediaUrl0,
                          mediaUrl1: message.mediaUrl1,
                          mediaUrl2: message.mediaUrl2,
                        }
                      }
                    }
                  } catch (e) {
                    val = JSON.parse(JSON.stringify(message.message))
                    if (typeof val === 'string' || val instanceof String) {
                      return {
                        direction: 'out',
                        img: 'images/avatar/bot.png',
                        name: 'Obex Bot',
                        time: moment(message.time).format(
                          'MM-DD-YYYY h:mm:ss a',
                        ),
                        message: message.message,
                        mediaUrl0: message.mediaUrl0,
                        mediaUrl1: message.mediaUrl1,
                        mediaUrl2: message.mediaUrl2,
                      }
                    }
                  }
                } else {
                  return {
                    direction: message.Direction,
                    img:
                      message.Direction === 'in'
                        ? 'images/avatar/traveler.png'
                        : 'images/avatar/agent.png',
                    name:
                      message.Direction === 'in'
                        ? memberInfo.FirstName +
                          ' ' +
                          memberInfo.LastName +
                          '(' +
                          message.FromNumber +
                          ')'
                        : loginMember.FirstName + ' ' + loginMember.LastName,
                    time: moment(message.time).format('MM-DD-YYYY h:mm:ss a'),
                    message: message.Message,
                    mediaUrl0: message.MediaUrl0,
                    mediaUrl1: message.MediaUrl1,
                    mediaUrl2: message.MediaUrl2,
                  }
                }
              })

              console.log('$scope.chats ', $scope.chats)
            })

          //context
          console.log('topic 715', topic)
          if (topic) {
            if (typeof topic === 'number') {
              conversationService
                .getTopic($scope.traveler.Email)
                .then((response) => {
                  console.log('Topic 747', response.data)
                  setBookingDetails(response.data)
                })
            } else {
              setBookingDetails(topic)
            }
          }
        })
      } else {
        $scope.isInConversation = false
        $scope.conversationTitle = 'You are not assisting'
      }

      //on socket event
      $scope.$on('incomingText', function (event, data) {
        console.log('smsController incomingText ', event, data)
        $scope.$apply(function () {
          if (data.isBot) {
            let val
            try {
              val = JSON.parse(data.message)
              console.log('DEBUG => ', val)
              if (typeof val === 'object' || val instanceof Object) {
                const templateType = val.template_type
                if (templateType === 'generic') {
                  const elements = val.elements
                  $scope.chats.push({
                    direction: 'out',
                    img: 'images/avatar/bot.png',
                    name: 'Obex Bot',
                    time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                    message: undefined,
                    template: elements.map((m) => {
                      return {
                        title: m.title,
                        subtitle: m.subtitle,
                        image_url: m.image_url,
                      }
                    }),
                    templateType: templateType,
                    mediaUrl0: data.mediaUrl0,
                    mediaUrl1: data.mediaUrl1,
                    mediaUrl2: data.mediaUrl2,
                  })
                } else if (
                  templateType === 'airline_itinerary' ||
                  templateType === 'airline_checkin'
                ) {
                  $scope.chats.push({
                    direction: 'out',
                    img: 'images/avatar/bot.png',
                    name: 'Obex Bot',
                    time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                    message: undefined,
                    template: {
                      intro_message: val.intro_message,
                      pnr_number: val.pnr_number,
                      passenger_info: val.passenger_info[0],
                      flight_info: val.flight_info[0],
                      passenger_segment_info: val.passenger_segment_info[0],
                      total_price: val.total_price,
                      currency: val.currency,
                    },
                    templateType: templateType,
                    mediaUrl0: data.mediaUrl0,
                    mediaUrl1: data.mediaUrl1,
                    mediaUrl2: data.mediaUrl2,
                  })
                } else if (templateType === 'airline_update') {
                  $scope.chats.push({
                    direction: 'out',
                    img: 'images/avatar/bot.png',
                    name: 'Obex Bot',
                    time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                    message: undefined,
                    template: {
                      intro_message: val.intro_message,
                      pnr_number: val.pnr_number,
                      flight_info: val.update_flight_info,
                    },
                    templateType: templateType,
                    mediaUrl0: data.mediaUrl0,
                    mediaUrl1: data.mediaUrl1,
                    mediaUrl2: data.mediaUrl2,
                  })
                } else if (templateType === 'list') {
                  const elements = val.elements
                  $scope.chats.push({
                    direction: 'out',
                    img: 'images/avatar/bot.png',
                    name: 'Obex Bot',
                    time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                    message: undefined,
                    template: elements.map((m) => {
                      return {
                        title: m.title,
                        subtitle: m.subtitle,
                      }
                    }),
                    templateType: templateType,
                    mediaUrl0: data.mediaUrl0,
                    mediaUrl1: data.mediaUrl1,
                    mediaUrl2: data.mediaUrl2,
                  })
                }
              }
            } catch (e) {
              val = JSON.parse(JSON.stringify(data.message))
              if (typeof val === 'string' || val instanceof String) {
                $scope.chats.push({
                  direction: 'out',
                  img: 'images/avatar/bot.png',
                  name: 'Obex Bot',
                  time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                  message: data.message,
                  mediaUrl0: data.mediaUrl0,
                  mediaUrl1: data.mediaUrl1,
                  mediaUrl2: data.mediaUrl2,
                })
              }
            }
          } else {
            if (
              $scope.chats.length &&
              $scope.conversationTitle.includes(data.fromNumber)
            ) {
              $scope.chats.push({
                direction: 'in',
                img: 'images/avatar/traveler.png',
                name:
                  data.firstName +
                  ' ' +
                  data.lastName +
                  '(' +
                  data.fromNumber +
                  ')',
                time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
                message: data.message,
                mediaUrl0: data.mediaUrl0,
                mediaUrl1: data.mediaUrl1,
                mediaUrl2: data.mediaUrl2,
              })
              if (
                data.message.includes(
                  'The traveler does not want to chat at this time.',
                )
              ) {
                $scope.istravellerIgnore = true
              } else {
                $scope.istravellerIgnore = false
              }
            }
          }
        })
      })
      $scope.$on('outgoingText', function (event, data) {
        console.log('smsController outgoingText ', event, data)
        $scope.$apply(function () {
          $scope.chats.push({
            direction: 'out',
            img: 'images/avatar/agent.png',
            name: data.firstName + ' ' + data.lastName,
            time: moment(data.time).format('MM-DD-YYYY h:mm:ss a'),
            message: data.message,
          })
        })
      })
      //on user's action
      $scope.attachSms = function () {
        dialogId = ngDialog.open({
          template: 'templates/partials/attachFileForSms.html',
          className: 'ngdialog-theme-plain',
          scope: $scope,
          closeByEscape: false,
          closeByDocument: false,
        })
      }
      $scope.$watch('files', function () {
        if ($scope.filesToSend) {
          //from binding in template
          if ($scope.filesToSend.length > 3) {
            alert('Only maximum of 3 files is allowed')
          }
        }
      })
      $scope.smsAttachment = function (files, chatParam) {
        if (files && files.length) {
          for (var i = 0; i < files.length; i++) {
            var file = files[i]
            console.log(file)
            if (file != null) {
              conversationService
                .sendAttachment(file, chatParam)
                .then(function (result) {
                  const cloudinaryObj = result.data
                  const public_filename =
                    cloudinaryObj.public_id + '.' + cloudinaryObj.format // e.g. 'filename.jpg'
                  console.log(
                    'conversationService.sendAttachment result',
                    result,
                  )
                  $scope.closeThisDialog(dialogId)
                })
            }
          }
        }
      }
      $scope.confirmSendAttachmentToSms = function () {
        if ($scope.filesToSend.length < 1) {
          alert('You must select at least 1 file')
        } else if ($scope.filesToSend.length > 3) {
          alert('You can not send more than 3 files')
        } else {
          $scope.isSending = true
          const loginMember = authService.getLoginMember()
          const chatParam = {
            socketId: socketLogin.getSocketId(),
            agentId: loginMember.Id,
            agentFirstName: loginMember.FirstName,
            agentLastName: loginMember.LastName,
            agentEmail: loginMember.Email,
            agentOrganizationId: loginMember.OrganizationId,
            agencyName: loginMember.Organization.Name,
            smstext: '',
            topic: topic,
            travelerId: travelerId,
            travelerNumber: fromNumber,
            travelerFirstName: firstName,
            travelerLastName: lastName,
            channel: $scope.channel === null ? 'sms' : $scope.channel,
          }
          $scope.smsAttachment($scope.filesToSend, chatParam)
        }
      }
      $scope.sendSms = function () {
        const loginMember = authService.getLoginMember()
        loginMember['SupportsOrganizations'] = []
        if (
          $scope.smstext !== undefined &&
          $scope.smstext.length > 0 &&
          fromNumber !== null &&
          fromNumber.length > 0
        ) {
          $http.post('/textOut', {
            fromNumber: fromNumber,
            socketId: socketLogin.getSocketId(),
            firstName: loginMember.FirstName,
            lastName: loginMember.LastName,
            email: loginMember.Email,
            organizationId: loginMember.OrganizationId,
            loginMember: loginMember,
            smstext: $scope.smstext,
            topic: topic,
            travelerId: travelerId,
            channel: channel === null ? 'sms' : channel,
          })
          $scope.smstext = ''
        }
      }
      $scope.finishConversation = function () {
        const confirmMessage =
          'This is to confirm that you finish assisting the traveler. If so, you can click on the Yes button.  This tab will be closed and future messages from the traveler will not show up here.'
        ngDialog
          .openConfirm({
            template: confirmMessage + commonDialog.confirmDialog,
            className: 'ngdialog-theme-plain',
            plain: true,
          })
          .then(function (value) {
            const loginMember = authService.getLoginMember()
            //progress.start()
            const smsData = {
              fromNumber: fromNumber,
              travelAgentEmail: loginMember.Email,
              status: smsStatus.Finished,
              message:
                'Agent ' +
                loginMember.FirstName +
                ' ' +
                loginMember.LastName +
                ' finished conversation',
              channel: $scope.channel,
              travelAgentId: loginMember.Id,
              travelerId: travelerId,
              topic: topic,
              socketId: socketLogin.getSocketId(),
              organizationId: loginMember.Organization.Id,
            }
            $http.post('/finish', smsData)
            $rootScope.$broadcast('removeFinishSms', smsData)
            $state.go('app')
            //progress.complete()
          })
      }
      $scope.onKeyPressed = function (keyEvent) {
        if (keyEvent.which === 13) {
          console.log('enter key ', keyEvent.which)
          $scope.sendSms()
        }
      }
    },
  ])
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/js/controllers/smsController.js